import { type DomainAccessControlConfig } from 'domains/products/utils/domain/accessControl'
import { Flipper } from 'domains/products/access-control/flippers'
import { Permission } from './permissions'

export const productsSearchAccessControl: DomainAccessControlConfig = {}

export const instacartInternalAccessControl: DomainAccessControlConfig = {
  permissions: Permission.InstacartInternal,
}

export const productSearchCPTButton: DomainAccessControlConfig = {
  warehouseFlippers: [Flipper.ProductSearchCPTButton],
}
